export default __webpack_public_path__ + "static/media/Modified_Lloyds_Davies_Female.54c0f28f.png";